import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { VITE_GOOGLE_API_KEY } from './config';

// injecting the script file inside of html until start is fine rather than
// injecting it when the specific page load to prevent not loading properly
const googleMapsApiKey = VITE_GOOGLE_API_KEY;
const googleMapsScript = document.createElement('script');
googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places`;
googleMapsScript.async = true;
googleMapsScript.defer = true;
document.head.appendChild(googleMapsScript);
const openCVScript = document.createElement('script');
openCVScript.src = `https://docs.opencv.org/4.x/opencv.js`;
openCVScript.async = true;
openCVScript.defer = true;
document.head.appendChild(openCVScript);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
